import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import {CustomAlert, CustomConfirm} from '../common/_Utilities.jsx';
import blAjax					from '../utils/_ajax.jsx';

export default class ContactSupport extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.MAX_SIZE = 2097152;

		this.state = {
			firstname: '',
			lastname: '',
			emailAddress: blapp.session.getMe() ? blapp.session.getMe().skEmailAddr : "",
			countryId: blapp.session.getMe() ? blapp.session.codeCountryDetected : '',
			subject: 'Other',
			message: '',
			isLoading: false,
			attemptToSubmit: 0
		}

		this.env = blapp.config.disable_xp || window.location.href.includes('/v3/') ? 'classic' : 'xp';
	}

	render() {
		return (
			<div className="main l-margin-top">
				<div className="main__content">
					<h1 className="l-margin-bottom text--mxl-title">Contact Support</h1>
					<p className="l-margin-bottom--xl">If you couldn’t find the answer to your question in the <a href={this.env === 'xp' ? 'https://www.bricklink.com/helpDesk.asp' : 'https://www.bricklink.com/helpDesk.asp'} target="_blank">Help Center</a>, use the contact form below to let us know how we can help.</p>
					{this.renderFields()}			
				</div>
			</div>
		);
	}

	renderFields() {
		const buttonDisabled 	= !this.isReadyToSubmit();
		const isEmailNotValid 	= ((this.state.emailAddress != "") && !blapp.util.isValidEmailAddr(this.state.emailAddress))?true:false;
		const isFirstnameMaxLength = (this.state.firstname.length == 40)?true:false;
		const isLastnameMaxLength = (this.state.lastname.length == 40)?true:false;
		const isMessageMaxLength = (this.state.message.length == 2000)?true:false;

		return (
			<section className="contact-fields">
				
				<div className="contact-fields__section-name l-margin-bottom--xl">
					<div className="contact-fields__section-name-firstname">
						<div className="text--bold">First name</div>
						<div className="l-relative"> 
							<input className={"l-full-width text-input " + ( (isFirstnameMaxLength)?"contact-fields__field--error-no-pad":"" )} placeholder="First name" value={this.state.firstname} onChange={(e) => this.updateValue('firstname', e.target.value)} maxLength="40"/>
						</div>
						{isFirstnameMaxLength && <small className="l-margin-top--sm l-block text-color--primaryRed">40 characters max</small>}
					</div>
					
					<div className="contact-fields__section-name-lastname">
						<div className="text--bold">Last name</div>
						<div className="l-relative"> 
							<input className={"l-full-width text-input " + ( (isLastnameMaxLength)?"contact-fields__field--error-no-pad":"" )} placeholder="Last name" value={this.state.lastname} onChange={(e) => this.updateValue('lastname', e.target.value)} maxLength="40"/>
						</div>
						{isLastnameMaxLength && <small className="l-margin-top--sm l-block text-color--primaryRed">40 characters max</small>}
					</div>			
					
				</div>

				<div className="l-block l-margin-bottom--xl">
					<strong className="l-block l-margin-bottom--sm">Email address</strong>
					<div className="l-relative">
						<input className={"text-input contact-fields__field" + ((isEmailNotValid) ? ' contact-fields__field--error' : '')} placeholder="Email address" value={this.state.emailAddress} onChange={(e) => this.updateValue('emailAddress', e.target.value)}/>
						{isEmailNotValid && <i className="fas fa-exclamation-triangle contact-fields__error-icon"/>}
					</div>
					{isEmailNotValid && <small className="l-margin-top--sm l-block text-color--primaryRed">Please enter a valid email address.</small>}
				</div>
				
				<div className="l-block l-margin-bottom--sm">
					<strong className="l-block l-margin-bottom--sm">Message</strong>
					<div className="l-relative">
						<textarea className={"textarea contact-fields__field contact-fields__field--textarea " + ( (isMessageMaxLength)?"contact-fields__field--error-no-pad":"" )}  placeholder="Provide details about your topic" value={this.state.message} onChange={(e) => this.updateValue('message', e.target.value)} maxLength="2000"></textarea>
					</div>
					{isMessageMaxLength && <small className="l-block text-color--primaryRed">2,000 characters max</small>}
				</div>
								
				<button className={"btn btn--cta text--bold l-margin-top--xl" + (this.state.isLoading ? ' btn--wait' : '')} disabled={buttonDisabled} onClick={() => this.submit()}>Submit</button>
			</section>
		);
	}

	isReadyToSubmit() {
		return (
			!blapp.util.isValidEmailAddr(this.state.emailAddress) || 
			this.state.emailAddress.trim() == '' || 
			this.state.message.trim() == '' || 
			this.state.isLoading ||
			this.state.firstname == '' ||
			this.state.lastname == ''
		)?false:true;
	}

	updateValue(type, value) {
		this.setState({[type]: value});
	}

	initInpFields( ) {
		this.setState({firstname:"", lastname:"", message:"", emailAddress: blapp.session.getMe() ? blapp.session.getMe().skEmailAddr : ''});
	}

	submitErr() {
		const message = (this.state.attemptToSubmit > 0) ? "Sorry, it seems like we're having some problems on our end. Please try again later." : "Oops! There was an error submitting your support ticket. Please try again.";
		this.triggerAlert(message);
	}

	submit() {
		this.setState({isLoading: true});
		const strFirstName = this.state.firstname;
		const strLastName = this.state.lastname;
		const strTopic = this.state.subject;
		const strEmail = this.state.emailAddress;
		const strMessage = this.state.message;
		const strCountryId = (this.state.countryId)?this.state.countryId:"";
		
		blAjax.call(
			"/createHelpDeskTicket.ajax"
		,	{
				strFirstName   : strFirstName, 
				strLastName    : strLastName, 
				strEmail       : strEmail, 
				strCountryId   : strCountryId, 
				strTopic       : strTopic,
				strMessage     : strMessage 
			}
		).then(
			( data ) =>
			{
				this.setState({isLoading: false});
				if (data.result == "EC_OK") {
					this.initInpFields();
					this.triggerConfirm();
					this.setState({attemptToSubmit: 0});
				} else {
					this.submitErr();
				}
			}
		).catch(
			( err ) =>
			{
				console.log(err);
				this.setState({isLoading: false});
				this.submitErr();
			}
		);

		/*
		blapp.models.fetch(
			"_send_support_request"
			, {
				controller: "support.BLCSupport"
				, method: "sendRequest"
				, params: [this.state.emailAddress, subject, this.state.message, this.state.files]
				, refresh: true
			}
		).then(
			(data) => {
				if (data == "EC_OK") {
					const message = "Your message was sent. We will do our best to get back to you within 1-2 business days.";
					let prevUrl = document.referrer != "" ? document.referrer : blapp.url2.getMainPageUrl();
					prevUrl = blapp.util.addParamToUrl('floatNotification', message, prevUrl);
					prevUrl = blapp.util.addParamToUrl('floatNotificationType', 'success', prevUrl);
					window.location.href = prevUrl;
				} else {
					this.setState({isLoading: false})
					this.triggerAlert( "Something went wrong! Please try it again later: " + data );
				}
			}
		).catch(
			(err) => {
				console.log(err)
				this.setState({isLoading: false});
				this.triggerAlert( "Something went wrong! Please try it again later!" );
			}
		);
		*/
		
	}

	triggerConfirm() {
		const confirmContent = '<h2 class="page-title l-margin-bottom--xl">Thank you for your submission!</h2><p class="l-margin-bottom--xl">We appreciate your feedback. Our Admin Team will review your submission.</p>';
		CustomAlert(confirmContent, "Done");
	}

	triggerAlert(message) {
		const confirmContent = `<i class="fas fa-exclamation-triangle l-margin-bottom accessibility__error-icon"></i><p class="l-margin-y--l">${message}</p>`;

		if (this.state.attemptToSubmit == 0 ) {		
			this.setState({attemptToSubmit: this.state.attemptToSubmit + 1});
			CustomConfirm(confirmContent, { 
				false:	'Cancel'
			,	true:	'Try again' 
			}, "", {buttonContainer: "accessibility__modal-button-container-retry", buttonTrue: "accessibility__modal-button", buttonFalse: "accessibility__modal-button"} )
			.then(value => {
				if(value == true) {
					this.submit();
				}
				else {
					this.setState({attemptToSubmit: 0});
				}
			});
		}
		else 
		{
			this.setState({attemptToSubmit: 0});
			CustomAlert(confirmContent, "Done");
		}
		
	}

};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<ContactSupport blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
